onReady(($) => {
    let wistiaLoaded = false;
    const allTabs = $('body.ds .page-content .dynamic-tabs')
        .toArray();
    const switchTab = (tabsModule, tabElement) => {
        if (tabElement.classList.contains('active')) {
            return;
        }

        $('.tab-pill.active', tabsModule)
            .removeClass('active');
        tabElement.classList.add('active');
        //Content Card Refresh Slick Slider
        const sliderElement = tabsModule.querySelector('.tab-content[data-tab-index="' + tabElement.dataset.tabIndex + '"] .slick-slider');
        if (sliderElement) {
            $(sliderElement)
                .slick('refresh');
        }

        $('.tab-content.active, .tab-content[data-tab-index="' + tabElement.dataset.tabIndex + '"]', tabsModule)
            .toggleClass('active');

        if (!wistiaLoaded && $('.tab-content.active .wistia_embed', tabsModule).length > 0) {
            loadWistiaLibrary();
            wistiaLoaded = true;
        }

        $('.leadership-profile-drawers .profile.active', tabsModule)
            .removeClass('active');

        // Scroll to top of tab pane
        window.scroll(0, findYPos(tabsModule) - 100);
    };

    // Switch tab panels logic
    for (const tabsModule of allTabs) {
        $('.tab-pill:not(.has-link)', tabsModule)
            .on('click', (event) => switchTab(tabsModule, event.target));
    }

    // Support wistia videos on content cards grid module
    const wistiaVideoOnActiveTabPanel = $('body.ds .page-content .dynamic-tabs .tab-content.active .wistia_embed').length > 0;
    if (wistiaVideoOnActiveTabPanel) {
        loadWistiaLibrary();
        wistiaLoaded = true;
    }

    // Sticky tab pills
    const tabsModulesWithStickyPillsElements = allTabs.filter((tabsModule) => tabsModule.classList.contains('has-sticky-pills'));

    // Switch tab to correct hash in URL
    const handleActiveHashTab = () => {
        if (!window.location.hash) {
            return;
        }
        for (const tabsModule of allTabs) {
            const activeHashTab = $('.tab-pills a[href="' + window.location.hash + '"] .tab-pill', tabsModule);
            if (activeHashTab.length === 0) {
                return;
            }
            switchTab(tabsModule, activeHashTab[0]);

            // Scroll to top of tab pane
            if (tabsModulesWithStickyPillsElements.length > 0) {
                window.scroll(0, findYPos(tabsModule) - 100);
            }
        }
    };
    window.addEventListener('hashchange', handleActiveHashTab);
    handleActiveHashTab();

    // Sticky tab pills
    if (tabsModulesWithStickyPillsElements.length === 0) {
        return;
    }
    const topNav = document.querySelector('.navigationcontainer, .landing-page-nav');
    const siteNotice = document.querySelector('#site-notice-padding');

    // Get and group the relevant elements for each tabs module
    const tabsModulesWithStickyPills = tabsModulesWithStickyPillsElements.map((module) => {
        return {
            module,
            pillContainer: module.querySelector('.tab-pill-container'),
            headingContainer: module.querySelector('.heading'),
            tabContentContainer: module.querySelector('.tab-content-container'),
        }
    })

    // Will enable/disable sticky pills
    const stickyPositionHandler = () => {
        // Define how close to the top the pills should be
        const topOffset = topNav.offsetHeight + (siteNotice ? siteNotice.offsetHeight : 0);

        for (const {module, pillContainer, headingContainer, tabContentContainer} of tabsModulesWithStickyPills) {
            // Make sticky
            if (headingContainer.getBoundingClientRect().bottom + 10 <= topOffset) {
                module.classList.add('sticky-pills');
                pillContainer.style.top = `${topOffset - 1}px`;
            }

            // Remove sticky when going up
            if (headingContainer.getBoundingClientRect().bottom + 10 > topOffset) {
                module.classList.remove('sticky-pills');
            }

            // Remove sticky when going past the end of the module
            if (tabContentContainer.getBoundingClientRect().bottom - 120 <= pillContainer.getBoundingClientRect().bottom) {
                module.classList.remove('sticky-pills');
            }
        }
    };
    stickyPositionHandler();

    // The site notice could be dismissed and affect the topOffset
    // We will observe any changes and update the offset if anything changes
    if (siteNotice) {
        new MutationObserver(stickyPositionHandler).observe(document.body, {attributes: true});
    }

    // On resize, the top navigation height might change so we will recalculate sticky positioning
    window.addEventListener('resize', stickyPositionHandler);

    // On scroll, determine sticky positioning
    window.addEventListener('scroll', stickyPositionHandler);
});
